module.exports = __webpack_public_path__ + "static/media/arrow_left.46a9fd66.svg";